import { Box, Typography } from "@material-ui/core";
import {
  EPOCUS_BORDER,
  EPOCUS_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "../epocus-palette";

interface Props {
  code: string;
  modifier: string | null;
  label?: string;
}

export const BillingCptChip: FC<Props> = ({
  code,
  modifier,
  label = "Suggested code",
}) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="flex-end"
    style={{ gap: 2 }}
  >
    <Typography
      style={{
        fontSize: rem(10),
        fontWeight: 700,
        letterSpacing: "0.08em",
        color: EPOCUS_TEXT_SECONDARY,
        textTransform: "uppercase",
      }}
    >
      {label}
    </Typography>
    <Box
      style={{
        backgroundColor: EPOCUS_WHITE,
        border: `1px solid ${EPOCUS_BORDER}`,
        borderRadius: 6,
        padding: "4px 10px",
      }}
    >
      <Typography
        style={{
          fontSize: rem(14),
          fontWeight: 700,
          color: EPOCUS_PRIMARY,
          letterSpacing: "0.02em",
        }}
      >
        {code}
        {modifier !== null ? ` — ${modifier}` : ""}
      </Typography>
    </Box>
  </Box>
);
